import React, { Component } from 'react';
import { Formik, FieldArray } from 'formik';
import { Alert, Button, Checkbox, Dialog, Pane, Text, Heading, TextInputField, SelectField, WarningSignIcon, CrossIcon } from 'evergreen-ui';
import { Icon } from 'evergreen-ui'
import Request from '../../../util/Api';


class OrderStatusProcessedModal extends Component {
    constructor (props) {
        super(props);

        this.classes = props.classes;
        this.onClose = this.onClose.bind(this);

        // Falls back to Sameday-only if the fetch fails, preserving the
        // pre-DPD behavior. Enabled set comes from the shipping registry.
        this.state = { providers: [{ id: 'sameday', label: 'Sameday', logo: 'sameday' }] };
    }

    async componentDidMount () {
        try {
            const res = await Request.get('/v2/shipping/enabled-providers');
            const providers = (res && res.data) || [];
            if (providers.length > 0) this.setState({ providers });
        } catch (e) {
            // keep the Sameday fallback
        }
    }

    onClose = () => {
        this.props.onClose();
    }

    render () {
      // External orders ship only via DPD international — with DPD disabled
      // (absent from enabled-providers) they cannot be processed.
      const isExternal = !!(this.props.order.deliveryCountry && this.props.order.deliveryCountry !== 'RO');
      const dpdEnabled = this.state.providers.some((p) => p.id === 'dpd');
      const externalBlocked = isExternal && !dpdEnabled;
      return (<Dialog
        shouldCloseOnOverlayClick={false}
        width={1000}
        isShown={this.props.open}
        title= {"Procesare comanda"}
        hasFooter={false}
        onCloseComplete={this.onClose}
        onClose={this.onClose}>

            <Pane>
                <Formik initialValues={{
                            packed: true,
                            stocked: true,
                            emailNotifications: true,
                            smsNotifications: true,
                            packages: ['delivery', 'delivery-locker'].includes(this.props.order.delivery) ? [{width: 10, height: 10, length: 10}] : [],
                            personalDropoff: false,
                            // Everything defaults to Sameday; external orders can only pick DPD
                            // from the (currently disabled) provider grid below.
                            provider: 'sameday',
                            pickupPoint: 'PLOIESTI',
                        }}
                        enableReinitialize={true}
                        validateOnChange={false}
                        validateOnBlur={false}
                        onSubmit = {(values) => {
                            this.props.confirmOperation(values);
                            this.props.onClose();
                        }}
                >
                    {({errors, handleChange, handleBlur, handleSubmit, setFieldValue, values}) => {
                        const isDelivery = ['delivery', 'delivery-locker'].includes(this.props.order.delivery);
                        return <form>
                                    {!this.props.checks.stock ? 
                                        <Alert
                                            intent="danger"
                                            title="Produsele nu par a fi in stoc."
                                            marginBottom={32}
                                        /> : null}
                                    <Pane display="flex">
                                        <Pane width={600}>
                                            <Heading size={400}>Dimensiuni colete</Heading>
                                            <Text color="muted">Introdu dimensiunile coletelor care vor fi livrate</Text>
                                            {
                                                values.packages.length > 2 ? 
                                                <Text color="red" display="block">Nu putem folosi o cutie mai mare?</Text> : null
                                            }
                                            <FieldArray name="packages" render={arrayHelpers => (
                                                <Pane marginTop={10}>
                                                    {['delivery', 'delivery-locker'].includes(this.props.order.delivery) ?
                                                        <Button type="button" onClick={() => arrayHelpers.push({width: 10, height: 10, length: 10})}>Adauga colet</Button>
                                                    : <Alert intent="none" title="Comanda fara livrare prin curier, nu contine colete" marginBottom={16}/>}
                                                    {values.packages.map((pkg, i) => (<Pane display="flex" marginTop={10}>
                                                        <TextInputField
                                                            width={150}
                                                            marginRight={5}
                                                            required
                                                            label="Latime (cm)"
                                                            name={`packages.${i}.width`}
                                                            value={pkg.width || ""}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            />
                                                        <TextInputField
                                                            width={150}
                                                            marginRight={5}
                                                            required
                                                            label="Lungime (cm)"
                                                            name={`packages.${i}.length`}
                                                            value={pkg.length || ""}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            />
                                                        <TextInputField
                                                            width={150}
                                                            marginRight={5}
                                                            required
                                                            label="Inaltime (cm)"
                                                            name={`packages.${i}.height`}
                                                            value={pkg.height || ""}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            />
                                                        <Button type="button" onClick={() => arrayHelpers.remove(i)} marginTop={24} intent="danger">X</Button>
                                                    </Pane> ))}
                                                    
                                                </Pane>
                                            )} />
                                        </Pane>

                                        {/* <Pane padding={10} border="1px solid #444444" flexGrow={1}>
                                            <Heading size={400}>Confirmare procesare</Heading>
                                            <Pane display="flex">
                                                <Checkbox label="Produsele sunt in stoc" 
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    name="stocked"
                                                    checked={values.stocked}
                                                />

                                                {!this.props.checks.stock ? 
                                                    <Icon title="Verifica stocul produselor" icon={WarningSignIcon} color="warning" marginLeft={16} marginTop={16} /> : null}
                                            </Pane>
                                            <Pane display="flex">
                                                <Checkbox label="Comanda a fost impachetata"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    name="packed"
                                                    checked={values.packed}
                                                />
                                            </Pane>
                                       
                                            <Heading size={400}>Optiuni Notificari</Heading>
                                            <Pane display="flex">
                                                <Checkbox label="Trimite notificari prin email"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    name="emailNotifications"
                                                    checked={values.emailNotifications}
                                                    disabled={!this.props.checks.emailNotifications}
                                                />
                                                {!this.props.checks.emailNotifications ? 
                                                    <Icon title="Clientul a ales sa nu fie notificat pe email" icon={CrossIcon} color="muted" marginLeft={16} marginTop={16} /> : null}
                                            </Pane>
                                            
                                            <Pane display="flex">
                                                <Checkbox label="Trimite notificari prin sms"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    name="smsNotifications"
                                                    checked={values.smsNotifications}
                                                    disabled={!this.props.checks.smsNotifications}

                                                />

                                                {!this.props.checks.smsNotifications ? 
                                                    <Icon title="Clientul a ales sa nu fie notificat pe SMS" icon={CrossIcon} color="muted" marginLeft={16} marginTop={16} /> : null}
                                            </Pane>
                                        </Pane> */}

                                        <Pane padding={10} border="1px solid #444444" flexGrow={1}>
                                          {isDelivery ?
                                            <Pane marginBottom={16}>
                                                <Heading size={400} marginBottom={8}>Curier</Heading>
                                                {isExternal && !externalBlocked ?
                                                    <Alert intent="none" title="Comanda externa — se livreaza prin DPD international." marginBottom={8} /> : null}
                                                {externalBlocked ?
                                                    <Alert intent="warning" title="Comanda externa se livreaza doar prin DPD international, momentan dezactivat. Comanda nu poate fi procesata." marginBottom={8} /> : null}
                                                <Pane display="flex" flexWrap="wrap">
                                                    {(isExternal ? this.state.providers.filter((p) => p.id === 'dpd') : this.state.providers).map((p) => {
                                                        const selected = values.provider === p.id;
                                                        return <Pane
                                                            key={p.id}
                                                            is="button"
                                                            type="button"
                                                            onClick={() => setFieldValue('provider', p.id)}
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            cursor="pointer"
                                                            width={120}
                                                            height={56}
                                                            marginRight={10}
                                                            marginBottom={10}
                                                            padding={6}
                                                            background="white"
                                                            border={selected ? "2px solid #3366ff" : "1px solid #d8dae5"}
                                                            boxShadow={selected ? "0 0 0 3px rgba(51,102,255,0.15)" : null}
                                                            borderRadius={6}
                                                        >
                                                            <img
                                                                src={`/shipping-logos/${p.logo || (p.id + '.svg')}`}
                                                                alt={p.label}
                                                                title={p.label}
                                                                style={{ maxWidth: '100%', maxHeight: 40, opacity: selected ? 1 : 0.65 }}
                                                                onError={(e) => { e.target.style.display = 'none'; }}
                                                            />
                                                        </Pane>;
                                                    })}
                                                </Pane>
                                            </Pane>
                                          : null}

                                          {/* Sameday-only options: PLOIESTI/BRASOV pickup + easybox self-dropoff.
                                              DPD uses the account's default sender, so these are hidden for it. */}
                                          {values.provider === 'sameday' ?
                                            <>
                                              <SelectField
                                                label="Locatie Ridicare"
                                                name="pickupPoint"
                                                value={values.pickupPoint}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                validationMessage={errors.type}
                                              >
                                                <option value="PLOIESTI">Ploiesti</option>
                                                <option value="BRASOV">Brasov</option>
                                              </SelectField>
                                              {isDelivery ?
                                                  <Checkbox
                                                      label="Depun personal coletul in easybox"
                                                      name="personalDropoff"
                                                      checked={values.personalDropoff}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                  />
                                              : null}
                                            </>
                                          : null}

                                          {values.provider === 'dpd' && this.props.order.delivery === 'delivery-locker' ?
                                            <Alert intent="warning" title="Livrarea la easybox nu este mapata pentru DPD; se va genera AWB la adresa." marginTop={8} />
                                          : null}
                                        </Pane>
                                        
                                    </Pane>
                                
                                    <Pane borderTop="default" marginTop={16} paddingTop={16}>
                                        <Button type="submit" onClick={handleSubmit}
                                            disabled={(values.packages.length === 0 && this.props.order.delivery === 'delivery') || !values.packed || !values.stocked || externalBlocked}>
                                            Confirmare
                                        </Button>
                                    </Pane>
                                </form>
                    }}
                </Formik>
            </Pane>
      </Dialog>)
    }
}

export default OrderStatusProcessedModal;